import React, { useContext, useEffect, useState } from 'react'
import IPayData from './pay-data.interface'
import PayDataContext from './pay-data-context'
import AuthContext from '../auth/auth-context'
import Salary from './salary/salary'
import { ISalaryData } from './salary/salary.interface'
import DashboardContext from '../layout/dashboard-context'
import BugsnagContext from '../../context/bugsnag-context'
import StatisticsSubmitHeader from '../statistics-submit-header/statistics-submit-header'
import PayDataFrom from './pay-data-form'
import BillingInfo from '../billing-info/billing-info'
import PayDataText from './pay-data-text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import UsersPage from '../user-management/user-page'
import {useSearchParams , useNavigate} from 'react-router-dom'
import api from '../../api'

const PayData: React.FC<IPayData> = () => {
  const { setSalaries } = useContext(PayDataContext)
  const { token } = useContext(AuthContext)
  const { bugsnagClient } = useContext(BugsnagContext)
  const { selectedOrganization } = useContext(DashboardContext)
  const [currentYearReported, setCurrentYearReported] = useState(true)
  const [showFormbanner, setShowFormbanner] = useState(false)
  const [hasReceivedData, setHasReceivedData] = useState(false)
  const [reportedYears, setReportedYears] = useState([0])
  const [success, setSuccess] = useState(false)
  const [data, setData] = useState([])
  const [showPreviousYear, setShowPreviousYear] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams('')
  const [activeStep, setActiveStep] = React.useState(searchParams.get('step'))
  const navigate = useNavigate()

  bugsnagClient.metaData = {
    token,
    page: 'pay-data',
  }

  const tableHeads = [
    {
      label: 'Rapporteringsår',
    },
    {
      label: 'Lönesumma TFL',
    },
    {
      label: 'Lönesumma TRF',
    },
    {
      label: 'Lönesumma målare',
    },
    {
      label: 'Total Lönesumma',
    },
  ]

  const findYears = (data: Array<ISalaryData>) => {
    const tempArray = [0]
    tempArray.pop()
    for (const index in data) {
      if (!tempArray.includes(data[index].year)) {
        tempArray.push(data[index].year)
      }
    }
    setReportedYears(tempArray)
    if (!tempArray.includes(new Date().getFullYear() - 1)) {
      setCurrentYearReported(false)
      setShowFormbanner(true)
    } else {
      setCurrentYearReported(true)
      setShowPreviousYear(true)
      setShowFormbanner(false)
    }

    setShowPreviousYear(true)
  }

  const getPayData = async () => {
    try {
      setHasReceivedData(false)
      const res = await api.get(`/accounts/${selectedOrganization.id}/salaries`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      })

      setHasReceivedData(true)
      return res.data.data
    } catch (e) {
      bugsnagClient.notify(e)

      return []
    }
  }

  const getData = async () => {
    const data = await getPayData()
    data.sort((a: any, b: any) => {
      return b.year - a.year
    })
    setSalaries(data)
    setData(data)
    findYears(data)
  }

  useEffect(() => {
    setSalaries([])
    getData()
  }, [selectedOrganization])

  useEffect(() => {
    if (success) {
      searchParams.delete('step')
      setSearchParams({ step: '2' })
    }
  }, [success])

  return (
    <div className="card p-12 flex flex-col w-full bg-white">
      {showFormbanner && <StatisticsSubmitHeader label="Årslönesummor" acitveStep={activeStep} />}
      {hasReceivedData && (
        <div>
          {(!activeStep || activeStep === '1') && (
            <div>
              <PayDataText />

              {!currentYearReported && (
                <PayDataFrom
                  setCurrentYearReported={setCurrentYearReported}
                  setSuccess={setSuccess}
                />
              )}

              <div className="flex flex-col justify-between">
                {reportedYears && reportedYears.length > 0 && (
                  <div className="overflow-auto flex flex-col gap-4">
                    <button
                      className="text-darkBlue font-semibold text-md pl-1 mt-2 flex flex-row gap-2 items-center"
                      onClick={() => setShowPreviousYear(!showPreviousYear)}
                    >
                      Visa tidigare år
                      {showPreviousYear ? (
                        <FontAwesomeIcon icon={faChevronUp} />
                      ) : (
                        <FontAwesomeIcon icon={faChevronDown} />
                      )}
                    </button>

                    {showPreviousYear && (
                      <table className="table">
                        <thead className="thead">
                          <tr className="tr">
                            {tableHeads.map((head, index) => {
                              return (
                                <th key={index} className="th w-1/5 font-bold">
                                  {head.label}
                                </th>
                              )
                            })}
                          </tr>
                        </thead>
                        <tbody className="tbody">
                          {data && data.length > 0
                            ? data.map((salary, index) => {
                                return <Salary key={index} data={salary} />
                              })
                            : null}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          {activeStep === '2' && <BillingInfo fromForm setActiveStep={setActiveStep} />}
          {activeStep === '3' && (
            <div>
              <UsersPage fromForm />
              <button onClick={() => navigate('/')} className="btn">
                Uppgifterna stämmer
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default PayData
